module.exports = __webpack_public_path__ + "7dee50fd58ae73cd5131d1d20302dc08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/PPN_ASSETS/WalletCard_2023_MSH_en.jpg
// module id = 1510
// module chunks = 0